import { render, staticRenderFns } from "./SingleFile.vue?vue&type=template&id=1a880ea8&scoped=true"
import script from "./SingleFile.vue?vue&type=script&lang=js"
export * from "./SingleFile.vue?vue&type=script&lang=js"
import style0 from "./SingleFile.vue?vue&type=style&index=0&id=1a880ea8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a880ea8",
  null
  
)

export default component.exports